






























import { Component, Vue } from 'vue-property-decorator';
import { Message } from 'element-ui';

import { Page } from '@/enums/page.enum';
import BankAccountsModule from '@/store/bank-accounts';

@Component({
  name: 'AppLayout',
})
export default class AppLayout extends Vue {
  get Page() {
    return Page;
  }

  async created() {
    try {
      await BankAccountsModule.loadBankAccounts();

      Message.success('Bank accounts loaded');
    } catch (e) {
      console.log({ e });
      Message.error('Failed to load bank accounts');
    }
  }
}

